export default "__VITE_ASSET__D0uO3cQ2__"